import {chatSettingService} from '@/services/chatSetting.service';

const state = {
}

const actions = {
    async checkChatSetting({ dispatch, commit }) {
        try {
            const response =  await chatSettingService.checkChatSetting()
            if (response.success){
                return response.data
            }else{
                dispatch("alertError", response.data.message, { root: true });
                return response
            }
        } catch (error) {
            const message = (error && error.data && error.data.message) || error.message;
            dispatch("alertError", message, { root: true });
            return [];
        }
    },
    async storeChatSetting({ dispatch, commit }, payload) {
        try {
            const response =  await chatSettingService.storeChatSetting(payload)
            if (response.success){
                return response.data
            }else{
                dispatch("alertError", response.data.message, { root: true });
                return response
            }
        } catch (error) {
            const message = (error && error.data && error.data.message) || error.message;
            dispatch("alertError", message, { root: true });
            return false;
        }
    },
    async removeChatSetting({ dispatch, commit }) {
        try {
            const response =  await chatSettingService.removeChatSetting()
            if (response.success){
                return response.data
            }else{
                dispatch("alertError", response.data.message, { root: true });
                return response
            }
        } catch (error) {
            const message = (error && error.data && error.data.message) || error.message;
            dispatch("alertError", message, { root: true });
            return [];
        }
    },

    updateUserSeting({dispatch},payload){
        dispatch("updateUserInfo", payload, {root: true})
    }
}


export default {
    namespaced: true,
    state,
    actions,
}